import { Pipe, PipeTransform } from '@angular/core'
import { AutomationHandler, getAutomationHandler } from './automation-handlers'

@Pipe({ name: 'eventHandler' })
export class AutomationEventHandlerPipe implements PipeTransform {
  transform(value: AutomationHandler) {
    return getAutomationHandler(value)
  }
}
